import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import { createVinoskTheme } from './core/theme/theme';
import { store } from './presentation/store/store';
import { ROUTES } from './core/config/constants';
import { LoginPage } from './presentation/pages/auth/LoginPage';
import { RegisterPage } from './presentation/pages/auth/RegisterPage';
import { PrivateRoute } from './presentation/components/common/PrivateRoute';
import { HomePage } from './presentation/pages/bottles/HomePage';
import { SearchPage } from './presentation/pages/bottles/SearchPage';
import { ArchivedPage } from './presentation/pages/bottles/ArchivedPage';
import { ProfilePage } from './presentation/pages/profile/ProfilePage';
import BottleDetailPage from './presentation/pages/bottles/BottleDetailPage';
import { AddBottlePage } from './presentation/pages/bottles/AddBottlePage';

const theme = createVinoskTheme('dark');

const globalStyles = {
  body: {
    backgroundColor: theme.palette.background.default,
  },
  '*::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '*::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.background.paper,
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  },
  '*::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.primary.light,
  },
};

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
            
            <Route element={<PrivateRoute />}>
              <Route path={ROUTES.BOTTLES} element={<HomePage />} />
              <Route path={ROUTES.SEARCH} element={<SearchPage />} />
              <Route path={ROUTES.ARCHIVED} element={<ArchivedPage />} />
              <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
              <Route path={ROUTES.BOTTLE_DETAIL} element={<BottleDetailPage />} />
              <Route path={ROUTES.BOTTLE_ADD} element={<AddBottlePage />} />
              <Route path={ROUTES.BOTTLE_EDIT} element={<div>Edit Bottle (To implement)</div>} />
              <Route path={ROUTES.SETTINGS} element={<div>Settings (To implement)</div>} />
            </Route>
            
            <Route path="/" element={<Navigate to={ROUTES.LOGIN} replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
